import { useState, useEffect } from "react";
import PageHead from "../components/PageHead";
import { useTranslation } from "react-i18next";
import ModalCompanies from "../components/Modal/ModalCompanies";
import Table from "../components/Table";
import DeprecatedPagination from "../components/DeprecatedPagination";
import { TFunction } from "i18next";
import { getAxiosInstance } from "../utils/axiosInstance";
import { toast } from "react-toastify";
import EditModalCompanies from "../components/Modal/EditModalCompanies";
import dayjs from "dayjs";

const getColumns = (t: TFunction<any>) => [
    {
        Header: t("CRT_NO"),
        accessor: 'no'
    },
    {
        Header: t("Name"),
        accessor: 'name'
    },
    {
        Header: t("Created At"),
        accessor: 'createdAt'
    },
    {
        Header: t("Updated At"),
        accessor: 'updatedAt'
    }
]

interface Company {
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    placeOfBusiness: {
        id: string,
        name: string,
        address: string,
        type: number
    }[]
}

type ApiResponse = Company[];

const Companies = () => {
    const [newCompanyModal, setNewCompanyModal] = useState<boolean>(false);
    const { t } = useTranslation("translations");

    const [companies, setCompanies] = useState<any>([]);
    const [length, setLength] = useState<number>(0);
    const [companiesToRender, setCompaniesToRender] = useState<any>([])
    const [editModalCompaniesData, setEditModalCompaniesData] = useState<any>({});
    const [editModalCompanies, setEditModalCompanies] = useState<boolean>(false);

    const fetchData = async (currentPage: number = 1, perPage: number = 10) => {
        try {
            const res = await getAxiosInstance().get('/Companies', {
                params: {
                    PageNumber: currentPage,
                    PageSize: perPage
                }
            });
            const paginationData = JSON.parse(res.headers.pagination);

            setCompanies(transformResponse(res.data, (currentPage - 1) * perPage));
            setLength(paginationData.totalItems);
        } catch (e) {
            console.log(e);
            toast.error(
                t("SOMETHING_WENT_WRONG"),
                { position: toast.POSITION.BOTTOM_RIGHT }
            );
        }
    }

    const transformResponse = (data: ApiResponse, currentItem: number = 0) => {
        const processedData = [];
        let i = currentItem;
        for (const d of data) {
            i++;
            processedData.push({
                no: i,
                name: d.name,
                createdAt: dayjs(d.createdAt).format('YYYY-MM-DD').toString(),
                updatedAt: dayjs(d.updatedAt).format('YYYY-MM-DD').toString(),
                placeOfBusiness: d.placeOfBusiness,
                id: d.id
            })
        }
        return processedData;
    }

    const editDataCompanies = (data: any) => {
        setEditModalCompanies(true);
        setEditModalCompaniesData(data);
    }

    useEffect(() => {
        fetchData();
    }, [])

    useEffect(() => {
        setCompaniesToRender([...companies].slice(0, 10));
    }, [companies])

    return (
        <>
            <PageHead
                addTooltip={t("Add Company")}
                name={t("Companies")}
                onAddModal={() => setNewCompanyModal(true)}
            />
            <ModalCompanies isOpen={newCompanyModal}
                onClose={() => {
                    setNewCompanyModal(false);
                    fetchData();
                }} />

            <Table
                columns={getColumns(t)}
                data={companies}
                onRowClick={data => { editDataCompanies(data) }}
                Pagination={
                    <DeprecatedPagination
                        dataLegth={length}
                        fetchData={(page, perPage) => fetchData(page, perPage)}
                    />
                }
            />

            <EditModalCompanies
                isOpen={editModalCompanies}
                data={editModalCompaniesData}
                onClose={
                    () => {
                        setEditModalCompanies(false);
                        fetchData()
                    }
                }

            />
        </>
    )
}

export default Companies;